export default {
  blends: {
    validationMessage: {
      requiredMessage: "Ce champ est requis",
      isNumber: "Doit être un nombre",
      isValidNumber: "Doit être un nombre valide",
      noNegativeNumbers: "Ce champ doit être supérieur à zéro",
      atLeastTwoProducts: "Au moins deux produits sont requis"
    },
    exemptProducts: {
      eudrExemptProducts: "Produits exemptés de l'EUDR",
      addEUDRExemptProduct: "Ajouter un produit exempté de l'EUDR",
      updateEUDRExemptProduct: "Mettre à jour un produit exempté de l'EUDR",
      internalRefNumber: "Numéro de référence interne",
      supplier: "Fournisseur",
      containerID: "ID du conteneur",
      product: "Produit",
      quantity: "Quantité",
      dateAdded: "Date d'ajout",
      addProduct: "Ajouter un produit",
      selectDate: "Sélectionner une date",
      addContainer: "Ajouter un conteneur",
      containerInformation: "Informations sur le conteneur",
      containerInformationTT:
        "Ceci est un identifiant unique du conteneur. Veuillez insérer l'ID du conteneur ci-dessous.",
      supplierInformation: "Informations sur le fournisseur",
      supplierInformationTT:
        "Détails concernant l'entité fournissant des biens ou des services.",
      supplierTooltip:
        "Sélectionnez le fournisseur dans la liste préenregistrée dans le système.",
      addnewSupplier: "Ajouter un nouveau fournisseur",
      internalReferenceNumberMustBeAlphanumeric:
        "Le numéro de référence interne doit être alphanumérique",
      netMassMustBeValid: "La masse nette doit être valide",
      volumeMustBeNumeric: "Le volume doit être numérique",
      subProduct: "Sous-produit",
      netMass: "Masse nette",
      volume: "Volume",
      productDetail: "Détails du produit",
      placeOfActivity: "Lieu d'activité",
      countryOfActivity: "Pays d'activité",
      countryOfEntry: "Pays d'entrée",
      activity: "Activité",
      internalRefNo: "Numéro de référence interne",
      name: "Nom",
      email: "E-mail",
      phoneNumber: "Numéro de téléphone",
      country: "Pays",
      status: "Statut",
      addNewSupplier: "Ajouter un nouveau fournisseur",
      availableForBlends: "Disponible pour les mélanges",
      thisFieldIsRequired: "Ce champ est requis.",
      enterSupplierFirstName: "Entrez le prénom du fournisseur",
      enterSupplierLastName: "Entrez le nom de famille du fournisseur",
      enterEmailAddress: "Entrez l'adresse e-mail",
      enterPhoneNumber: "Entrez le numéro de téléphone",
      selectCountry: "Sélectionnez un pays",
      firstNameIsRequired: "Le prénom est requis",
      lastNameIsRequired: "Le nom de famille est requis",
      unAvailableForBlends: "Indisponible pour les mélanges",
      exemptAddedSuccessfully:
        "Le produit exempté de l'EUDR a été ajouté avec succès !",
      unExpectedErrorMsg: "Une erreur inattendue s'est produite. Veuillez réessayer.",
      availabilityStatusMsg:
        "Le statut de disponibilité pour les mélanges a été mis à jour avec succès.",
      updateProduct: "Mettre à jour le produit",
      exemptUpdatedSuccessfully:
        "Le produit exempté de l'EUDR a été mis à jour avec succès !",
      invalidNumericValue: "Valeur numérique invalide",
      containerIDTT:
        "Ceci est un identifiant unique du conteneur. Veuillez insérer l'ID du conteneur ci-dessous.",
      actions: "Actions"
    },
    
  
    blends: "Mélanges",
blendSetting: "Paramètres des mélanges",
eudrDueDiligence: "Diligence raisonnable EUDR",
createBlendDds: "Créer DDS de mélange",
country: "Pays",
countryTT: "Pays",
select: "Sélectionner",
edurDueDeligenceStatus: "Statut de diligence raisonnable EUDR",
dueDiligenceStatus: "Statut de diligence raisonnable",
EUDRDeforestationStatusTT: "Statut de déforestation EUDR",
dueDeligenceStatus: "Statut de diligence raisonnable",
uploadedToEU: "Téléchargé vers l'UE",
pending: "En attente",
underReview: "En cours d'examen",
compliant: "Conforme",
nonCompliant: "Non conforme",
processingFarm: "Exploitation en cours de traitement",
analyzingDeforestation: "Analyse de la déforestation",
writingToBlockchain: "Écriture sur la blockchain",
readyToProceed: "Prêt à poursuivre",
mitigationRequired: "Atténuation requise",
viewReport: "Voir le rapport",
share: "Partager",
copyAndCreateNew: "Copier et créer un nouveau",
remove: "Supprimer",
eudrRefNo: "EUDR/Numéro de référence interne",
finalProduct: "Titre du mélange et ID de lot de mélange",
noOfIngredients: "Nombre d'ingrédients",
farmsAndQuantity: "Fermes et quantités",
actions: "Actions",
confirmDialog: {
  delete: {
    title: "Supprimer le mélange",
    message: "Êtes-vous sûr de vouloir supprimer ce mélange ?",
    confirmBtn: "Confirmer",
    cancelBtn: "Annuler"
  }
},
searchBlend: "Rechercher par titre de mélange ou ID de lot de mélange",
blendDuplicatedSuccessfully: "Le mélange a été dupliqué avec succès.",
reportDeletedSuccessfully: "Rapport supprimé avec succès",

    
blendSettings: {
  dashboard: "Tableau de bord",
  blendSettings: "Paramètres des mélanges",
  importBlends: "Importer des mélanges",
  addNewBlend: "Ajouter un nouveau mélange",
  searchTitle: "Rechercher par titre de mélange",
  view: "Voir",
  edit: "Modifier",
  remove: "Supprimer",
  farms: "Fermes",
  blendCode: "Code du mélange",
  blendTitle: "Titre du mélange",
  description: "Description",
  "finalProductName&Code": "Nom et code du produit final",
  dateAdded: "Date ajoutée",
  actions: "Actions",
  addBlend: "Ajouter des paramètres de mélange",
  cancel: "Annuler",
  createBlend: "Créer des paramètres de mélange",
  generalData: "Données générales",
  generalDataTT: "Cette étiquette affiche toutes les données de l'écran.",
  blendTitleTT: "La liste déroulante est accessible en cliquant dessus, ce qui révèle une liste de mélanges disponibles à sélectionner.",
  enterHere: "Entrez ici",
  blendCodeTT: "Une zone de texte pour saisir le code unique attribué au mélange pour identification.",
  blendDescription: "Description du mélange",
  blendDescriptionTT: "Une zone de texte pour fournir une description détaillée du mélange.",
  finalProductName: "Nom du produit final",
  finalProductNameTT: "Une zone de texte pour saisir le nom du produit final associé au mélange.",
  finalProductCode: "Code du produit final",
  finalProductCodeTT: "Une zone de texte pour saisir le code du produit final lié au mélange.",
  processType: "Type de processus",
  processTypeTT: "Une liste déroulante pour afficher le type de processus de torréfaction ou de mélange utilisé pour ce mélange.",
  finalProductLotIdGen: "Générateur d'ID de lot de produit final de mélange",
  finalProductLotIdGenTT: "Choisissez un type pour la structure de l'ID de lot. Les options déterminent comment l'ID est généré et peuvent inclure du texte statique, des numéros séquentiels ou des éléments basés sur des dates.",
  productDetails: "Produits du mélange (ingrédients)",
  productDetailsTT: "Ajoutez au moins 2 produits et sous-produits. Pour en ajouter plus, cliquez sur 'Ajouter un autre produit'.",
  selectType: "Sélectionner le type",
  startCount: "Début du comptage",
  resetCounterEach: "Réinitialiser le compteur chaque ",
  enter: "Entrer",
  staticText: "Texte statique",
  incrementalNumber: "Numéro incrémental",
  year: "Année",
  month: "Mois",
  date: "Date",
  none: "Aucun",
  space: "Espace",
  "0001": "0001",
  resetCounter: "Réinitialiser le compteur chaque",
  selectSeparator: "Sélectionner le séparateur",
  previewLotId: "Aperçu de l'ID de lot",
  blendProducts: "Produits du mélange",
  blendProductsTT: "Produits du mélange",
  product: "Produit",
  productTT: "Une liste déroulante pour sélectionner la catégorie principale de produit.",
  selectProduct: "Sélectionner un produit",
  subProduct: "Sous-produit",
  subProductTT: "Une liste déroulante pour choisir le sous-produit spécifique lié au produit sélectionné.",
  selectSubProduct: "Sélectionner un sous-produit",
  originCountry: "Pays d'origine",
  originCountryTT: "Sélectionnez le pays d'origine de l'ingrédient.",
  selectCountry: "Sélectionner un pays",
  percentage: "Pourcentage",
  percentageTT: "Entrez le pourcentage du produit actuel dans le mélange global. Le total des pourcentages doit atteindre exactement 100.",
  addAnotherProduct: "Ajouter un autre produit",
  confirmation: "Confirmation",
  createBlendMessage: "Êtes-vous sûr de vouloir ajouter un nouveau mélange ?",
  updateBlendMessage: "Êtes-vous sûr de vouloir mettre à jour ce mélange ?",
  confirm: "Confirmer",
  pleaseFillRequiredFields: "Veuillez remplir les champs requis",
  lightRoast: "Torréfaction légère",
  mediumRoast: "Torréfaction moyenne",
  mediumDarkRoast: "Torréfaction moyennement foncée",
  darkRoast: "Torréfaction foncée",
  validation: {
    titleRequired: "Le titre est requis",
    codeRequired: "Le code du mélange est requis",
    descriptionRequired: "La description est requise",
    finalProductNameRequired: "Le nom du produit final est requis",
    finalProductCodeRequired: "Le code du produit final est requis",
    processTypeRequired: "Le type de processus est requis",
    selectTypeRequired: "Le type est requis",
    startCountRequired: "Le début du comptage est requis",
    selectSeparatorRequired: "Le séparateur est requis",
    finalProductLotIdGenRequired: "La génération de l'ID de lot de produit final est requise",
    productRequired: "Le produit est requis",
    subProductRequired: "Le sous-produit est requis",
    originCountryRequired: "Le pays d'origine est requis",
    percentageRequired: "Le pourcentage est requis",
    hundredPrecent: "Le pourcentage total doit atteindre exactement 100 %",
    productSubproductDuplicatedMsg: "Le produit et le sous-produit sont dupliqués",
  },
  mustSelectIncrementalNumber: "Au moins un numéro incrémental est requis",
  blendSettingsCreated: "Les paramètres du mélange ont été créés avec succès.",
  blendSettingsNotCreated: "Échec de la création des paramètres du mélange. Veuillez réessayer avec des données appropriées.",
  confirmDiaglog: {
    delete: {
      title: "Supprimer",
      message: "Êtes-vous sûr de vouloir supprimer ce paramètre de mélange ?",
      confirmBtn: "Confirmer",
      cancelBtn: "Annuler",
    },
  },
  itemDeletedSuccessfully: "Paramètre de mélange supprimé avec succès",
  updateBlend: "Mettre à jour les paramètres du mélange",
  save: "Enregistrer",
  blendSettingsUpdated: "Les paramètres du mélange ont été mis à jour avec succès.",
  blendSettingsNotUpdated: "Échec de la mise à jour des paramètres du mélange. Veuillez réessayer avec des données appropriées.",
  updateMessage: "Êtes-vous sûr de vouloir mettre à jour ce mélange ?",
  createMessage: "Êtes-vous sûr de vouloir ajouter un nouveau mélange ?",
  finalProductCodeAlreadyExists: "Le code du produit final existe déjà.",
  blendCodeAlreadyExists: "Le code du mélange existe déjà.",
  valueMustBeNumber: "Ce champ doit être un nombre",
  valueMustBeNonNegative: "Ce champ doit être supérieur à zéro",
},

imports: {
  imports: "Importations",
  blends: "Mélanges",
  createNewImport: "Créer une nouvelle importation",
  importsBlends: "Importations de mélanges",
  createBlends: "Créer des mélanges",
  downloadTemplateInfo:
    "Téléchargez et utilisez les modèles ci-dessous pour importer des géofences en masse.",
  selectTemplate: "Sélectionner un modèle",
  downloadXlsTemplate: "Télécharger le modèle d'importation au format XLS",
  downloadProductCodes: "Télécharger les codes produits",
  selectFileToUpload: "Sélectionnez un fichier pour télécharger les données",
  orDragDrop: "Ou faites glisser et déposez les fichiers ici",
  removeFile: "Supprimer le fichier",
  importantNote: "Note importante",
  templateNote:
    "Veuillez utiliser les modèles fournis ci-dessus pour les téléchargements en masse. Les autres formats entraîneront un échec.",
  importData:
    "Veuillez vous assurer que ces données ne seront pas conservées tant que tous les statuts ne seront pas réussis.",
  fileUploadSuccess: "Fichier téléchargé avec succès",
  invalidFileFormat: "Format de fichier invalide. Veuillez télécharger un fichier valide.",
  invalidTemplateUploaded:
    "Modèle invalide téléchargé. Veuillez utiliser le modèle correct et réessayer.",
  invalidTemplateUploadedMissing:
    "Modèle invalide téléchargé. Veuillez utiliser le modèle correct et réessayer. Il manque ces éléments",
  pleaseSelectSource: "Veuillez sélectionner au moins une source",
  blendTitle: "Titre du mélange",
  blendCode: "Code du mélange",
  finalProductCode: "Code du produit final",
  finalProductName: "Nom du produit final",
  status: "Statut",
  downloadCsvTemplate: "Télécharger le modèle d'importation au format CSV",
  dropHere: "ou faites glisser et déposez ici",
  Importing: "Importation en cours...",
  modalMessage:
    "Votre fichier téléchargé est en cours de traitement. Nous vous notifierons une fois le fichier téléchargé avec succès.",
  importXLSFormat: "Importer au format XLS",
  importCSVFormat: "Importer au format CSV",
  fileSelected: "Le fichier a été sélectionné avec succès.",
  success: "Les données ont été importées avec succès.",
  importCompleted: "Importation terminée",
  invalidHeaders: "En-têtes de fichier invalides",
  headerMismatchErro: "Le fichier téléchargé doit contenir les en-têtes suivants",
  missingHeaders: "En-têtes manquants",
  additionalHeaders: "En-têtes supplémentaires (non autorisés)"
},

history: {
  history: "Historique",
  fileName: "Nom du fichier",
  importedOn: "Importé le",
  status: "Statut",
  action: "Action",
  blends: "Mélanges",
  download: "Télécharger",
  success: "Succès",
  failed: "Échoué"
},
createBlends: {
  eudrDueDiligence: "Diligence raisonnable EUDR",
  createBlends: "Créer des mélanges",
  discard: "Abandonner",
  reject: "Rejeter",
  saveAndContinueLater: "Sauvegarder et continuer plus tard",
  generateReport: "Générer le rapport",
  generalData: "Données générales",
  blend: "Mélange",
  selectBlend: "Sélectionner le mélange",
  blendCode: "Code du mélange",
  blendDescription: "Description du mélange",
  finalProduct: "Produit final",
  finalProductCode: "Code du produit final",
  netMass: "Masse nette",
  netMassTT: "Permet aux utilisateurs de saisir la valeur de la masse nette associée à un produit, un envoi ou une transaction.",
  volume: "Volume",
  volumeTT: "L'étiquette est affichée à côté d'un champ ou d'une section où les données liées au volume sont présentées ou saisies, telles que dans les spécifications du produit ou les formulaires d'expédition.",
  blendLotId: "ID du lot de mélange",
  blendLotIdTT: "Affiche l'identifiant unique du lot selon la configuration des paramètres de mélange pour le suivi du lot.",
  finishedProductLotId: "ID du lot de produit fini",
  finishedProductLotIdTT: "Entrez l'identifiant unique du lot pour le suivi du lot de produit final.",
  enterHere: "Entrez ici",
  internalReferenceNumber: "Numéro de référence interne",
  internalReferenceNumberTT: "Code de référence interne pour le suivi",
  eudrReferenceNumber: "Numéro de référence EUDR",
  eudrReferenceNumberTT: "Code de référence pour la conformité à la réglementation EUDR (Union Européenne sur la déforestation). Il sera pré-rempli si l'utilisateur souhaite télécharger après la création du rapport.",
  companyId: "ID de l'entreprise",
  companyIdTT: "Identifiant de l'entreprise associée à ce mélange.",
  activity: "Activité",
  domestic: "National",
  import: "Importation",
  export: "Exportation",
  containerInformation: "Informations sur le conteneur",
  containerInformationTT: "C'est un identifiant unique du conteneur. Veuillez insérer l'ID du conteneur ci-dessous.",
  addContainer: "Ajouter un conteneur",
  blendProduct: "Produit de mélange",
  blendProductTT: "Ajouter plusieurs produits et sous-produits de produits exemptés DDS/EUDR pour créer un mélange.",
  product: "Produit",
  productTT: "Affiche le produit choisi parmi une liste de produits disponibles dans les paramètres de mélange pour le traitement, l'analyse ou le reporting au sein de l'application, facilitant la saisie et la gestion des données.",
  subProduct: "Sous-produit",
  subProductTT: "Affiche le sous-produit choisi parmi les sous-produits disponibles dans les paramètres de mélange liés à un produit principal sélectionné, facilitant la saisie détaillée des données.",
  ddsId: "ID DDS",
  containerId: "ID du conteneur",
  uniqueContainerId: "L'ID du conteneur doit être unique",
  containerIdTT: "Identifiant unique du conteneur portant ce mélange.",
  country: "Pays",
  countryTT: "Choisissez le pays associé à l'origine ou à la destination du mélange.",
  search: "Rechercher",
  select: "Sélectionner",
  addAnotherProduct: "Ajouter un autre produit",
  customization: "Personnalisation",
  recordsPerPage: "Enregistrements par page",
  restoreDefault: "Restaurer les paramètres par défaut",
  apply: "Appliquer",
  applyFilter: "Appliquer le filtre",
  clearFilter: "Effacer le filtre",
  status: {
    compliant: "Conforme",
    nonCompliant: "Non conforme",
    eudrExempt: "Exempté EUDR",
    uploadToEudr: "TÉLÉCHARGÉ SUR LE PORTAIL UE"
  },
  table: {
    eudrInternalRef: "Réf. interne EUDR",
    containerId: "ID du conteneur",
    product: "Produit",
    farmsQuantity: "Fermes & Quantité",
    submissionDate: "Date de soumission",
    dueDiligenceStatus: "Statut de la diligence raisonnable",
    availabilityForBlends: "Disponibilité pour les mélanges",
    pleaseSelectSource: "Veuillez sélectionner au moins une source"
  },
  productionPlaceTable: {
    productionPlaceAndFarmId: "Lieu de production & ID de la ferme",
    product: "Produit",
    producerName: "Nom du producteur",
    addressOfProduction: "Adresse de production",
    status: "Statut de déforestation EUDR",
    riskAssessment: "Évaluation des risques"
  },
  addNewSupplier: "Ajouter un nouveau fournisseur",
  addNewBlend: "Ajouter un nouveau mélange",
  placeOfActivity: 'Lieu d’Activité de l’Opérateur',
  placeOfActivityTT: "Précisez le pays de l'opérateur où les activités sont effectuées et le pays où le produit entre sur le marché de l'UE. Ces détails sont essentiels pour garantir la conformité aux exigences de l'EUDR.",
  countryOfActivity: 'Pays d’Activité de l’Opérateur',  
  countryOfActivityTT: "Sélectionnez le pays où se déroule cette activité.",
  countryOfEntry: "Pays d'entrée",
  countryOfEntryTT: "Sélectionnez le pays d'entrée pour les produits importés.",
  pleaseSelectAtLeastOne: "Veuillez sélectionner au moins un rapport de chaque produit",
  blendCreatedSuccessfully: "Le mélange a été créé avec succès.",
  blendCreateFailed: "Une erreur est survenue lors de la création du mélange.",
  blendUpdatedSuccessfully: "Le mélange a été mis à jour avec succès.",
  blendUpdateFailed: "Une erreur est survenue lors de la mise à jour du mélange.",
  blendDeletedSuccessfully: "Le mélange a été supprimé avec succès.",
  blendSavedSuccessfully: "Le mélange a été sauvegardé avec succès.",
  blendUploadedToEUSuccessfully: "Le mélange a été téléchargé avec succès sur l'UE.",
  declaration_first: "{name}, déclare par la présente que toutes les données soumises avec cet envoi sont exactes au mieux de ma connaissance et de ma conviction.",
  declaration_second: "Je, {name}, affirme avoir visité les fermes associées à cet envoi et confirme leur conformité avec les lois et règlements locaux concernant la déforestation."
},

manageProducts: {
  addNewProduct: 'Ajouter un nouveau produit',
  editProduct: 'Modifier le produit',
  addNewSubProduct: 'Ajouter un nouveau sous-produit',
  editSubProduct: 'Modifier le sous-produit',
  productTitle: 'Titre du produit',
  subProductTitle: 'Titre du sous-produit',
  typeTitle: 'Saisir le titre',
  hsCode: 'Code HS',
  typeHSCode: 'Saisir le code HS',
  eudrDocumentCode: 'Code de document EUDR',
  selectEudrDocumentCode: 'Sélectionner le code de document EUDR',
  makeSelection: 'Faire une sélection',
  uploadCategoryImage: 'Télécharger une image de catégorie',
  addImage: 'Ajouter une image',
  cancel: 'Annuler',
  save: 'Enregistrer',
  back: 'Retour',
  add: 'Ajouter',
  confirm: 'Confirmer',
  deleteMessage: 'Êtes-vous sûr de vouloir supprimer',
  invalidFileType: 'Type de fichier invalide',
  errorUploadingFile: 'Une erreur inattendue est survenue lors du téléchargement du fichier. Veuillez réessayer plus tard.',
  fileUploadFailed: 'Échec du téléchargement du fichier',
  selectDocumentCode: 'Sélectionner le code de document',
  view: 'Voir',
  edit: 'Modifier',
  remove: 'Supprimer',
  search: 'Rechercher',
  searchByProductName: 'Rechercher par nom de produit',
  eudrDueDiligence: 'Diligence raisonnable EUDR',
  products: 'Produits',
  subProducts: 'Sous-produits',
  fieldRequired: 'Ce champ est obligatoire',
  fileRequired: 'Fichier requis',
  fileRequiredMessage: 'Veuillez télécharger ou sélectionner un fichier avant d’enregistrer le produit.',
  addNewDocumentCode: 'Ajouter un nouveau code de document',
  enterHere: 'Entrez ici',
  documentCode: 'Code de document',
  title: 'Titre',
  description: 'Description',
  updateProduct: 'Mettre à jour le produit',
  updateSubProduct: 'Mettre à jour le sous-produit',
  deleteSubProduct: 'Supprimer le sous-produit',
  deleteProduct: 'Supprimer le produit',
  productAddedMessage: 'Le produit a été ajouté avec succès.',
  subProductAddedMessage: 'Le sous-produit a été ajouté avec succès.',
  productUpdateMessage: 'Le produit a été mis à jour avec succès.',
  subProductUpdateMessage: 'Le sous-produit a été mis à jour avec succès.',
  subProductDeleteMessage: 'Le sous-produit a été supprimé avec succès.',
  productDeleteMessage: 'Le produit a été supprimé avec succès.',
  pleaseTryAgain: 'Une erreur est survenue. Veuillez réessayer plus tard.',
  documentCodeDuplicate: 'Le code de document existe déjà',
  unsupportedFileFormat: 'Format de fichier non pris en charge. Veuillez télécharger un fichier image valide.',
  tableHeaders: {
      productName: 'Nom du produit',
      hsCode: 'Code HS',
      eudrDocumentCode: 'Code de document EUDR',
      subProduct: 'Sous-produits',
      dateAdded: 'Date d’ajout',
      action: 'Actions',
  },
  documentCodeSaved: 'Le code de document a été enregistré avec succès.',
},
finalReport: {
  title: 'Rapport final des mélanges',
  reportStatus: 'Statut du rapport',
  blendTitle: 'Titre du mélange',
  blendCode: 'Code du mélange',
  finalProduct: 'Produit final',
  finalProductCode: 'Code du produit final',
  blendDescription: 'Description du mélange',
  processType: 'Type de processus',
  netMass: 'Masse nette',
  volume: 'Volume',
  blendLotId: 'ID du lot de mélange',
  finalProductLotId: 'ID du lot de produit final',
  internalReferenceNumber: 'Numéro de référence interne',
  eudrReferenceNumber: 'Numéro de référence EUDR',
  activity: 'Activité',
  countryOfActivity: 'Pays d’activité',
  countryOfEntry: 'Pays d’entrée',
  dueDiligenceReportStatus: 'Statut du rapport de diligence raisonnable',
  containerId: 'ID du conteneur',
  operatorData: 'Données de l’opérateur',
  name: 'Nom',
  country: 'Pays',
  isoCode: 'Code ISO',
  eoriNumber: 'Numéro EORI',
  reportSummary: {
      title: 'Résumé du rapport',
      totalDdsReports: 'Nombre total de rapports DDS',
      totalGeofencePolygons: 'Nombre total de polygones de géofence',
      totalGeofencePoints: 'Nombre total de points de géofence',
      totalDeforestationAssessments: 'Nombre total d’évaluations de déforestation',
      totalRiskAssessments: 'Nombre total d’évaluations de risques',
      totalFarms: 'Nombre total de fermes',
      totalHighDeforestationFarms: 'Nombre total de fermes à haute déforestation',
      totalLowZeroRiskFarms: 'Nombre total de fermes à faible ou zéro risque',
      totalArea: 'Superficie totale (ha)',
      averageGeofenceArea: 'Superficie moyenne de géofence (ha)',
      totalHighRiskFarmArea: 'Superficie totale des fermes à haut risque',
      totalLowZeroRiskFarmArea: 'Superficie totale des fermes à faible ou zéro risque',
      productionPlaces: 'Lieux de production',
      productionPlacesTooltip: 'Détails sur les lieux de production',
      declarationStatement: 'Déclaration de l’opérateur',
      declarationStatementTooltip: 'Déclaration officielle de l’opérateur',
      declarationText1: '[Nom] {name}, déclare par la présente que toutes les données soumises avec cet envoi sont exactes au mieux de ma connaissance et croyance.',
      declarationText2: 'Moi, [Nom] {name}, confirme avoir visité les fermes associées à cet envoi et atteste leur conformité avec les lois locales concernant la déforestation.',
  },
  blendProducts: {
      title: 'Produits mélangés',
      product: 'Produit',
      subProduct: 'Sous-produit',
      country: 'Pays',
      reference: 'Référence EUDR / Interne',
      containerId: 'ID du conteneur',
      farmsQuantity: 'Fermes & Quantité',
      submissionDate: 'Date de soumission',
      status: 'Statut',
  },
  activityLog: {
      title: 'Journal d’activité',
      user: 'Utilisateur',
      userRole: 'Rôle de l’utilisateur',
      ipAddress: 'Adresse IP',
      dateTime: 'Date & heure',
      segment: 'Segment',
      activityDescription: 'Description de l’activité',
  },
  declaration: {
      title: 'Déclaration de l’opérateur',
      name: 'Nom',
      address: 'Adresse',
      dateTime: 'Date & heure',
  },
  buttons: {
      discard: 'Abandonner',
      reject: 'Rejeter',
      edit: 'Modifier',
      finalize: 'Finaliser',
      download: 'Télécharger',
      uploadToEuPortal: 'Téléverser sur le portail EU',
      update: 'Mettre à jour',
      submit: 'Soumettre',
  },
},
  }
};